import * as index from '@syncfusion/ej2-progressbar';
index.ProgressBar.Inject( index.ProgressAnnotation);
export * from '@syncfusion/ej2-progressbar';
